/**
 * Reseller create flow (CLA-906) — eager twin.
 *
 * Eagerly registers the file route; the page component and its atom/RPC/design
 * imports are deferred to `new.lazy.tsx` so they load only when an admin opens
 * this route, never in the always-loaded `main` chunk (CLA-645). The admin gate
 * is re-applied by the parent `admin_/resellers` layout route's `beforeLoad`.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/clawinstall/admin_/resellers/new")({});
